import axios from "axios";
import consts from "../consts";
import { setErroAPI } from "../common/toast/toast";

export function setModoTela(modo, registro = {}) {
    return {
        type: "DIAGNOSTICO_ENERGIA_MODO_TELA",
        payload: {
            modo: modo,
            registro: registro,
        },
    };
}

export function setFiltro(filtro) {
    return {
        type: "DIAGNOSTICO_ENERGIA_FILTRO",
        payload: filtro,
    };
}

export function setAguardando(aguardando) {
    return {
        type: "DIAGNOSTICO_ENERGIA_SET_AGUARDANDO",
        payload: aguardando,
    };
}

export function resetarFiltro() {
    return (dispatch, getState) => {
        dispatch({
            type: "DIAGNOSTICO_ENERGIA_RESETAR_FILTRO",
            payload: null,
        });
    };
}

export function setSituacaoAtual(payload) {
    return async (dispatch, getState) => {
        dispatch({
            type: "DIAGNOSTICO_ENERGIA_LISTADO",
            payload: payload,
        });
    };
}

export function buscarSituacaoAtual() {
    return async (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;
        if (!usuarioLogado) return {};
        dispatch(setAguardando(true));

        try {
            const state = getState().diagnosticoEnergia;
            if (!parseInt(state.filtro.id_unidade_consumidora)) return {};

            dispatch({
                type: "DIAGNOSTICO_ENERGIA_LISTADO",
                payload: {},
            });

            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;

            const resposta = await axios.get(
                `${consts.API_URL}/diagnosticoEnergia/buscarConsumoPorUcPeriodo?id_cliente=${idCliente}&id_unidade_consumidora=${state.filtro.id_unidade_consumidora}&competencia_inicial=${state.filtro.competencia_inicial}&competencia_final=${state.filtro.competencia_final}`
            );

            dispatch({
                type: "DIAGNOSTICO_ENERGIA_LISTADO",
                payload: resposta.data || {}, //recebe um {} ou null
            });
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function buscarTarifasSimulacaoOptante({ nome_subgrupo_faturamento, nome_modalidade_tarifaria }, callback) {
    return async (dispatch, getState) => {
        const usuarioLogado = getState().auth.usuarioLogado;
        if (!usuarioLogado) return {};
        dispatch(setAguardando(true));

        try {
            const state = getState().diagnosticoEnergia;
            if (!parseInt(state.filtro.id_unidade_consumidora)) return {};

            dispatch(setTarifasSimulacaoAneel());

            const idCliente = usuarioLogado.acesso_cliente ? usuarioLogado.id_cliente : state.filtro.id_cliente;

            const resposta = await axios.get(
                `${consts.API_URL}/diagnosticoEnergia/buscarTarifasAneel?id_cliente=${idCliente}&id_unidade_consumidora=${state.filtro.id_unidade_consumidora}&competencia_inicial=${state.filtro.competencia_inicial}&competencia_final=${state.filtro.competencia_final}&nome_subgrupo_faturamento=${nome_subgrupo_faturamento}&nome_modalidade_tarifaria=${nome_modalidade_tarifaria}`
            );
            if (callback) {
                //seta o resultado no state do componente que chamou a action
                callback(resposta.data);
            }
            dispatch(setTarifasSimulacaoAneel(resposta.data));
        } catch (erro) {
            setErroAPI(erro);
        } finally {
            dispatch(setAguardando(false));
        }
    };
}

export function setTarifasSimulacaoAneel(
    payload = {
        tarifa_energia_tusd: 0,
        tarifa_energia_te: 0,
        tarifa_energia_fora_ponta_tusd: 0,
        tarifa_energia_fora_ponta_te: 0,
        tarifa_energia_ponta_tusd: 0,
        tarifa_energia_ponta_te: 0,
    }
) {
    return {
        type: "DIAGNOSTICO_ENERGIA_TARIFAS_SIMULACAO",
        payload,
    };
}

export function getListaCliente() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = await axios.get(`${consts.API_URL}/cliente/listarSelect?id_empresa=${idEmpresa}`);
            dispatch({
                type: "DIAGNOSTICO_ENERGIA_CLIENTE_SELECT_LISTADO",
                payload: request,
            });
        } catch (error) {
            setErroAPI(error);
        }
    };
}

export function getListaUnidadeConsumidora() {
    return async (dispatch, getState) => {
        try {
            const usuarioLogado = getState().auth.usuarioLogado;
            if (!usuarioLogado) return {};

            const idEmpresaDashboard = getState().dashboard.filtro.id_empresa;
            const idEmpresa = usuarioLogado.id_empresa || idEmpresaDashboard;

            const request = await axios.get(`${consts.API_URL}/unidadeConsumidora/listarSelect?id_empresa=${idEmpresa}`);
            dispatch({
                type: "DIAGNOSTICO_ENERGIA_UNIDADE_CONSUMIDORA_SELECT_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

export function getListaModalidadeMercadoLivre() {
    return async (dispatch, getState) => {
        try {
            const request = await axios.get(`${consts.API_URL}/modalidadeMercadoLivre/listarSelect`);
            dispatch({
                type: "DIAGNOSTICO_ENERGIA_MODALIDADE_MERCADO_LIVRE_SELECT_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}

export function getListaTipoEnergiaMercadoLivre() {
    return async (dispatch, getState) => {
        try {
            const request = await axios.get(`${consts.API_URL}/tipoEnergiaMercadoLivre/listarSelect`);
            dispatch({
                type: "DIAGNOSTICO_ENERGIA_TIPO_ENERGIA_MERCADO_LIVRE_SELECT_LISTADO",
                payload: request,
            });
        } catch (e) {
            setErroAPI(e);
        }
    };
}
